
export type GetProjectCommentsParams = {
/**
 * 조회할 답글의 부모 댓글 ID (지정하지 않으면 루트 댓글 조회)
 */
parentId?: number;
/**
 * 페이지 번호
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
